// extracted by mini-css-extract-plugin
module.exports = {"confirmButton":"_3DovPI","footer":"_1a1l_S","textCancel":"_3gqhhU"};